import React from 'react';
import CampaignIcon from '@mui/icons-material/Campaign';
import SmsIcon from '@mui/icons-material/Sms';
import { EmptyState, TableEmptyRow } from '../ui';

const COPY = {
  email: {
    title: 'No campaigns found',
    description:
      'Start your email marketing journey by creating your first campaign. Send targeted emails to your contact groups and track opens, clicks, and engagement metrics.',
    hint: 'Visit Create Campaign to send your first email campaign.',
  },
  sms: {
    title: 'No SMS campaigns found',
    description:
      'Send your first SMS campaign to subscribed contacts. Track delivery status, segments, and credits as reports arrive from your SMS provider.',
    hint: 'Visit Create Campaign to compose and send your first message.',
  },
};

export function getCampaignEmptyProps(channel = 'email') {
  const text = COPY[channel] || COPY.email;
  const Icon = channel === 'sms' ? SmsIcon : CampaignIcon;
  return { icon: Icon, ...text };
}

const CampaignEmptyState = ({ channel = 'email', colSpan }) => {
  const props = getCampaignEmptyProps(channel);

  if (colSpan) {
    return <TableEmptyRow colSpan={colSpan} {...props} />;
  }

  return <EmptyState {...props} />;
};

export default CampaignEmptyState;
